import { jsx as o, jsxs as t } from "react/jsx-runtime";
import { Markdown as k } from "../../../components/Markdown/index.js";
import { getTimeAgoString as x } from "../../../services/time/index.js";
import { Theme as D } from "../../../styles/themes/index.js";
import { useDropdownContext as I } from "../../../contexts/Dropdown/context.js";
import { Container as S, Content as w, ImageContainer as y, Image as B, TextContainer as N, TitleContainer as j, ClickableItem as v, InfosContainer as A, DealInfos as L, NotificationDealStamp as M, Timestamp as P, StyledLink as R, StyledButton as $ } from "./style.js";
import { useTranslation as q } from "../../../hooks/useTranslation/index.js";
import { useTranslationContext as z } from "../../../contexts/TranslationProvider/context.js";
import { ChevronRight as E } from "@pelando/fontawesome/icons";
const F = ({
  children: n,
  url: i,
  target: r,
  onClick: e
}) => i ? /* @__PURE__ */ o(R, { url: i, onClick: e, target: r, children: n }) : /* @__PURE__ */ o($, { onClick: e, children: n });
function X({
  image: n,
  text: i,
  date: r,
  link: e,
  unread: m,
  deal: a,
  onClick: s,
  getNotificationUrl: d
}) {
  const { t: l } = q("common"), { locale: f } = z(), { closeDropdown: p } = I(), { store: c, id: h } = a || {}, { url: C, target: g } = d(h || "", e), u = x(new Date(r), f || ""), b = {
    "--backgroundColor": `rgb(${D.colors.Papa}`
  }, T = () => {
    s(), p();
  };
  return /* @__PURE__ */ o(
    S,
    {
      "aria-label": l(m ? "notification-bar-item-aria-label-unread" : "notification-bar-item-aria-label-read"),
      style: m ? b : void 0,
      children: /* @__PURE__ */ o(
        F,
        {
          url: C,
          onClick: T,
          target: g,
          children: /* @__PURE__ */ t(w, { children: [
            /* @__PURE__ */ o(y, { children: /* @__PURE__ */ o(B, { src: n, alt: "" }) }),
            /* @__PURE__ */ t(N, { children: [
              /* @__PURE__ */ t(j, { children: [
                /* @__PURE__ */ o(k, { children: i }),
                /* @__PURE__ */ o(v, { icon: E })
              ] }),
              /* @__PURE__ */ t(A, { children: [
                /* @__PURE__ */ t(L, { children: [
                  c == null ? void 0 : c.name,
                  " ",
                  a && "-",
                  /* @__PURE__ */ o(M, { deal: a })
                ] }),
                /* @__PURE__ */ o(P, { dateTime: r, children: u })
              ] })
            ] })
          ] })
        }
      )
    }
  );
}
export {
  X as NotificationBarItem
};
